import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";

export default function AdminCms() {
  const [pages, setPages] = useState([]);
  const [active, setActive] = useState(null);
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");

  useEffect(() => { api.get("/cms").then(({ data }) => { setPages(data); if (data[0]) select(data[0]); }); }, []);
  const select = (p) => { setActive(p.slug); setTitle(p.title); setContent(p.content); };
  const save = async () => { await api.put(`/cms/${active}`, { title, content }); toast.success("Page saved"); };

  return (
    <div data-testid="admin-cms">
      <PageHeader title="CMS Pages" subtitle="Manage website content pages" />
      <div className="grid lg:grid-cols-4 gap-6">
        <div className="space-y-1">
          {pages.map((p) => (
            <button key={p.slug} onClick={() => select(p)} data-testid={`cms-${p.slug}`}
              className={`w-full text-left px-4 py-2.5 rounded-md text-sm font-medium ${active === p.slug ? "viriks-navy text-white" : "bg-white border border-border hover:bg-muted"}`}>{p.title}</button>
          ))}
        </div>
        <div className="lg:col-span-3 bg-white border border-border rounded-lg p-6">
          <label className="text-sm font-medium">Title</label>
          <Input value={title} onChange={(e) => setTitle(e.target.value)} className="mb-4 mt-1" data-testid="cms-title" />
          <label className="text-sm font-medium">Content (HTML)</label>
          <Textarea value={content} onChange={(e) => setContent(e.target.value)} rows={12} className="mt-1 font-mono text-xs" data-testid="cms-content" />
          <Button className="viriks-navy text-white mt-4" onClick={save} data-testid="cms-save">Save Page</Button>
        </div>
      </div>
    </div>
  );
}
